/**
 * What the recovery page learned, handed to the wallet dashboard so it can
 * offer the one-tap sweep after sign-in. Session-scoped: it names two of
 * the customer's own addresses and nothing secret.
 */
export interface RecoveryContext {
	/** The recovered (oddly spelled) wallet the customer is now signed into. */
	from: string
	/** The standard-spelling wallet — where a normal restore lands them. */
	to: string
	/** Which spelling opened the funded wallet, for the panel's copy. */
	spelling: string
	balance: number
	inscriptions: number
	startedAt: number
}

const KEY = 'ow:recovery'

export function saveRecoveryContext(ctx: RecoveryContext): void {
	try {
		sessionStorage.setItem(KEY, JSON.stringify(ctx))
	} catch {}
}

/** The stored string itself, for `useSyncExternalStore` (stable identity). */
export function readRawRecoveryContext(): string | null {
	try {
		return sessionStorage.getItem(KEY)
	} catch {
		return null
	}
}

export function readRecoveryContext(): RecoveryContext | null {
	try {
		const raw = sessionStorage.getItem(KEY)
		if (!raw) return null
		const ctx = JSON.parse(raw)
		return ctx && typeof ctx.from === 'string' && typeof ctx.to === 'string' ? ctx : null
	} catch {
		return null
	}
}

export function clearRecoveryContext(): void {
	try {
		sessionStorage.removeItem(KEY)
	} catch {}
}
